module.exports = __webpack_public_path__ + "assets/img/index-partner18.8659eb91.jpg";